import camelCase from "lodash-es/camelCase";

import { TextAlign } from "types/TextAlign";

const TEXT_ALIGN_PREFIX = "text-align";

export const withTextAlign = (styles: CSSModuleClasses, align: TextAlign) =>
  styles[camelCase(`${TEXT_ALIGN_PREFIX}-${align}`)];
